document.addEventListener('turbolinks:load',function(){

  // var str = document.getElementById('username').innerHTML;
  if(document.getElementById('username')){
    var str = document.getElementById('username').innerText
    var split = str.split(' ')[0];
    split = 'Olá, '+split;
    document.getElementById('username').innerText = split;
  }
 
});